import React from 'react';
import { Reveal } from './Reveal';
import { bonuses, bonusTotalValue } from '../data/bonuses';
import { areBonusValuesPublic, formatAmount } from '../utils/checkout';
export function BonusesSection() {
  const showAmounts = areBonusValuesPublic();
  return <section aria-labelledby="bonuses-title" className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-23" data-mp="vqtcoz1w3tzw">
      <Reveal className="mx-auto max-w-3xl" data-id="element-24" data-mp="qvw6dzvzvyqp">
        <div className="mb-12 text-center" data-id="element-25" data-mp="14t2p5ugpxxfx">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand-teal-ink" data-id="element-26" data-mp="14rrk7rbjejn8">
            POUR ALLER PLUS LOIN AU QUOTIDIEN
          </p>
          <h2 id="bonuses-title" className="mt-4 text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-27" data-mp="1ejnib2dmi9rg">
            5 bonus inclus dans la collection
          </h2>
          <p className="mt-4 text-slate-600" data-id="element-28" data-mp="1njsnd5vcgw2g">
            {showAmounts ? <>
                Valeur indicative totale&nbsp;:{' '}
                <span className="font-bold text-brand-teal-ink" data-id="element-29" data-mp="1jk1sor2p5vsn">{formatAmount(bonusTotalValue)}</span> — inclus dans
                la collection
              </> : 'Cinq dossiers complémentaires, inclus dans la collection.'}
          </p>
        </div>
        <div className="space-y-4" data-id="element-30" data-mp="2k1997xzulkj">
          {bonuses.map(({
          title,
          description,
          value,
          image
        }, index) => {
          const number = String(index + 1).padStart(2, '0');
          return <article key={title} className="flex items-center gap-4 rounded-2xl bg-white p-3 shadow-sm sm:gap-6 sm:p-4" data-id="element-31" data-mp="cjabsp6xd8ii" data-mpi={index}>
                <img src={image} alt={`Couverture du bonus ${number}\u00A0: ${title}`} width={1024} height={1024} loading="lazy" decoding="async" className="aspect-square h-auto w-24 shrink-0 rounded-xl bg-brand-ivory object-contain sm:w-32" data-id="element-32" data-mp="lbu1h058o2r7" />
                <div className="min-w-0 flex-1" data-id="element-33" data-mp="akz57y5ziwjp">
                  <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-brand-teal-ink" data-id="element-34" data-mp="aliekqhkkcm4">
                    Bonus {number}
                  </p>
                  <h3 className="mt-1 text-base font-bold leading-snug text-brand-navy md:text-lg" data-id="element-35" data-mp="kba9xmxht9rn">{title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-36" data-mp="fjaf28wa571x">{description}</p>
                  <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-id="element-37" data-mp="tap2qt14twfb">
                    {showAmounts ? <span className="text-slate-600" data-id="element-38" data-mp="ocdtokinvpy5">
                        Valeur indicative&nbsp;:{' '}
                        <span className="font-semibold line-through" data-id="element-39" data-mp="137tmynbf3hth">{formatAmount(value)}</span>
                      </span> : <span className="font-semibold text-slate-600" data-id="element-40" data-mp="352asy0vk05bz">Inclus dans la collection</span>}
                    <span className="rounded-full bg-brand-turquoise/15 px-2.5 py-1 font-extrabold tracking-wide text-brand-teal-ink" data-id="element-41" data-mp="303r51uxegjgz">
                      OFFERT
                    </span>
                  </p>
                </div>
              </article>;
        })}
        </div>
      </Reveal>
    </section>;
}